import { GridItemPeriod, SeasonsGridItem } from './types/api/seasonTypes'

export const sortSeasonPeriods = (seasons: SeasonsGridItem[]) => {
  return seasons
    .map(seasonWithSortedPeriod => ({
      ...seasonWithSortedPeriod,
      periods: seasonWithSortedPeriod.periods.sort((a: GridItemPeriod, b: GridItemPeriod) =>
        a?.dateRange?.start?.valueOf() > b?.dateRange?.start?.valueOf() ? 1 : -1,
      ),
    }))
    .sort((a: SeasonsGridItem, b: SeasonsGridItem) =>
      a?.periods[0]?.dateRange?.start?.valueOf() > b?.periods[0]?.dateRange?.start?.valueOf()
        ? 1
        : -1,
    )
}
